import { useEffect } from 'react';

/**
 * Runs an effect exactly once on mount. The sanctioned escape hatch for
 * mount-only side-effects (see the no-use-effect skill); callers must NOT close
 * over reactive values they expect to track — remount via `key` when inputs
 * change.
 */
// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = effect => useEffect(effect, []);

export default useMountEffect;
